.eg{color:var(--brand-primary);}